// extracted by mini-css-extract-plugin
export default {"wrapper":"Promotion_wrapper__xN-vB","header":"Promotion_header__vWmqO","image":"Promotion_image__+e6z2","link":"Promotion_link__NxCj9","content":"Promotion_content__K5lb-"};